import NoData from "assets/svgs/no_data/NoData";
import { isEmpty } from "lodash";
import { useManageSegmentStore } from "modules/manage_segment/store";
import PaginationDiv from "modules/pagination/PaginationDiv";
import { fourPlaceHolder, getValue } from "modules/utilities/utility";
import React, { useEffect, useMemo, useState } from "react";
import { Form } from "react-bootstrap";
import { useToast } from "modules/navbar/top/store/toasterStore";
import CardDiv from "modules/common/card-div/CardDiv";
import { Button, Input } from "antd";
import { Link } from "react-router-dom";
import ManageSegmentModal from "modules/manage_segment/ManageSegmentModal";
import SegmentViewAll from "modules/manage_segment/SegmentViewAll";
import { DeleteOutlined, FileTextOutlined } from "@ant-design/icons";

function ManageSegment() {
  const {
    segmentData,
    segmentLoading,
    fetchSegmentData,
    updateActiveStatus,
    deleteSegment,
  } = useManageSegmentStore();
  const [page, newPage] = useState(1);
  const { setToaster } = useToast();
  const [searchText, setSearchText] = useState("");
  const { Search } = Input;
  const [contentKey, setContentKey] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [condition, setCondition] = useState("");
  const [viewModalShow, setViewModalShow] = useState(false);

  useEffect(() => {
    if (searchText) {
      const debounceTimeout = setTimeout(() => {
        const keyword = `keyword=${searchText}&`;
        fetchSegmentData(page - 1, keyword);
      }, 700);
      return () => {
        clearTimeout(debounceTimeout);
      };
    } else {
      fetchSegmentData(page - 1, "");
    }
  }, [page, searchText]);

 const segData = useMemo(() => {
    if (isEmpty(segmentData?.data)) return [];
    return segmentData?.data.results.map((row) => ({
      key: getValue(row, "id"),
      segmentName: getValue(row, "display_name"),
      switch: getValue(row, "is_active"),
      condition: JSON.parse(row.meta.ref),
      type: getValue(row, "type"),
    }));
  }, [segmentData?.data]);

  const handleCheckBox = (event, id, active) => {
    const check = event.target.checked ? true : false;
    updateActiveStatus(
      id,
      setToaster,
      check,
      fetchSegmentData,
      searchText,
      newPage
    );
  };

  const handleSearch = (value) => {
    setSearchText(value);
  };

  const handleEdit = (id) => {
    setContentKey(id);
    setModalShow(true);
  };

  const handleDelete = (id) => {
    deleteSegment(id, setToaster, fetchSegmentData, searchText, newPage);
  };

  const handleView = (value) => {
    setCondition(value);
    setViewModalShow(true);
  };

  const header = ["Segment Name", "Condition Name", "Active Status", "Action"];

  return (
    <div>
      <CardDiv
        title={
          <div className="d-flex justify-content-between">
            <div className="fs-2">Manage Segments</div>
            <div>
              <Search
                allowClear
                placeholder="Search"
                onSearch={handleSearch}
                onChange={({ target }) => handleSearch(target.value)}
                maxLength={80}
              />
            </div>
          </div>
        }
        component={
          <>
            <div>
              <div className="mt-1 shadow rounded mt-2">
                <div className="d-flex table-head rounded-top">
                  {header?.map((item) => {
                    return (
                      <span className="p-3 py-4 fw-bold text-black flex-1 border-end">
                        {item}
                      </span>
                    );
                  })}
                </div>
                {segmentLoading ? (
                  fourPlaceHolder()
                ) : segData && segData?.length ? (
                  segData?.map((item, index) => {
                    return (
                      <div
                        className={`d-flex table-row border-1 border-top-0 ${
                          index === segmentData?.data?.result?.length - 1 &&
                          `rounded-bottom`
                        }`}
                        key={item?.key}
                      >
                        <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                          <Link
                            to={`/manage-segment/segmentDetail/${item?.key}/${item?.segmentName}`}
                            className="text-primary fw-bold"
                          >
                            {" "}
                            {item?.segmentName}
                          </Link>
                        </span>
                        <span
                          className="p-3 flex-1 text-break text-wrap border-end cursor-pointer text-primary fw-bold"
                          onClick={() => handleView(item?.condition)}
                        >
                          View All
                        </span>
                        <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                          <Form.Check
                            type="checkbox"
                            id="checkedCheckbox"
                            label={item?.switch?"Active":"Inactive"}
                            onClick={(event) =>
                              handleCheckBox(event, item?.key, item?.switch)
                            }
                            defaultChecked={item?.switch ? true : false}
                          />
                        </span>
                        <span className="p-3 d-flex gap-4 flex-1 text-break text-black text-wrap border-end">
                          <Button
                            disabled={item.type !== "custom"}
                            onClick={() => handleEdit(item?.key)}
                            type="link"
                            icon={<FileTextOutlined />}
                          />

                          <Button
                            disabled={item.type !== "custom"}
                            onClick={() => handleDelete(item?.key)}
                            type="link"
                            icon={<DeleteOutlined />}
                            className=""
                          />
                        </span>
                      </div>
                    );
                  })
                ) : (
                  <div className="p-3 bg-white rounded-bottom text-center">
                    {" "}
                    No Data Available <NoData />
                  </div>
                )}
              </div>
            </div>
            <div>
              <PaginationDiv
                paginationData={{
                  pageCount: segmentData?.data?.total
                    ? Math.ceil(segmentData?.data?.total / 10)
                    : 1,
                  page: page,
                }}
                newPage={newPage}
              />
            </div>
          </>
        }
      />
      <ManageSegmentModal
        modalShow={modalShow}
        setModalShow={setModalShow}
        contentKey={contentKey}
      />
      <SegmentViewAll
        modalShow={viewModalShow}
        setModalShow={setViewModalShow}
        condition={condition}
      />
    </div>
  );
}

export default ManageSegment;
